import { Injectable } from "@angular/core";

@Injectable()

export class GenericService {
	public uncapitalizeResponse(response: any): any {
		let newO, origKey, newKey, value;
		if (response instanceof Array) {
			return response.map((v) => {
				if (typeof v === "object") {
					value = this.uncapitalizeResponse(v);
				}
				return value;
			});
		} else {
			newO = {};
			for (origKey in response) {
				if (response.hasOwnProperty(origKey)) {
					newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
					value = response[origKey];
					if (value instanceof Array || (value !== null && value.constructor === Object)) {
						value = this.uncapitalizeResponse(value);
					}
					newO[newKey] = value;
				}
			}
		}
		return newO;
	}
}
